import Joi from 'joi';

import { AppSubjectEnum } from '../../../../shared/modules/authz/enums/app-subject.enum';
import { createCompanyCustomerContactSchema } from '../../../../shared/modules/contacts/validators/schemas/create-company-customer-contact.schema';
import { createIndividualCustomerContactSchema } from '../../../../shared/modules/contacts/validators/schemas/create-individual-customer-contact.schema';
import { createTenantDriverSchema } from '../../../drivers/validators/schemas/create-tenant-driver.schema';
import { createPoliciesAssignSchema } from '../../../policies/validators/schemas/policies-assign.schema';
import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';
import { CustomerTypeEnum } from '../../enums/customer-type.enum';

/**
 * Schema for new customer record validation.
 */
export const createCustomerSchema = () =>
  Joi.object({
    // Type
    type: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|customer-type|cannot-be-null',
        }),
        otherwise: Joi.string()
          .valid(...Object.values(CustomerTypeEnum))
          .required()
          .messages({
            'any.required': 'validations|customer-type|required',
            'any.only': 'validations|customer-type|invalid-value',
          }),
      })
      .required()
      .messages({
        'any.required': 'validations|customer-type|required',
      })
      .prefs({ abortEarly: true }),

    // Contact
    contact: Joi.object().when('type', {
      is: Joi.valid(CustomerTypeEnum.INDIVIDUAL),
      then: createIndividualCustomerContactSchema(18),
      otherwise: Joi.object().when('type', {
        is: Joi.valid(CustomerTypeEnum.COMPANY),
        then: createCompanyCustomerContactSchema(),
      }),
    }),

    // Driver
    driver: createTenantDriverSchema().allow(null),

    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|customer-notes|must-be-string',
    }),

    externalReference: Joi.string().allow(null, '').messages({
      'string.base': 'validations|customer-external-reference|must-be-string',
    }),

    // Tags
    tags: createTagsSchema().messages({
      'array.base': 'validations|customer-tags|invalid-value',
    }),

    policies: createPoliciesAssignSchema(AppSubjectEnum.CUSTOMER),

    files: Joi.any().allow(null),
  })
    // Ignore extra fields
    .unknown();
